<template>
    <div>
        <div class="row">
            <div class="col-xl-9 m-b-10">
                <b-card no-body>
                    <b-table id="itemTable" striped sort-icon-left show-empty empty-text="There are no matching items to show" :items="this.itemsInType(activeEvent.id)" :per-page="perPage" :current-page="currentPage" :fields="fields">
                        <template v-slot:head(selected)>
                            <b-form-checkbox v-model="itemsCheck" @change="checkAll">Select all</b-form-checkbox>
                        </template>
                        <template v-slot:head(4SItems)>
                            4S Items
                        </template>
                        <template v-slot:cell(selected)="{ item }">
                            <b-form-checkbox size="lg" :value="item" v-model="selectedItems" @change="itemCheck" :checked="true" />
                        </template>
                        <template v-slot:cell(image)="{ item }">
                            <img :src="getImage(item.image)" width="100px" />
                        </template>
                        <template v-slot:cell(name)="{ item }">
                            {{ item.name }}
                        </template>
                        <template v-slot:cell(confirmed)="{ item }">
                            {{ checkStepStatus(item) ? 'Yes' : 'No' }}
                        </template>
                        <template v-slot:cell(4SItems)="{ item }">
                            Space: {{ filterScriptItemsByType(item.id, 'space') }}<br/>
                            Stuff: {{ filterScriptItemsByType(item.id, 'stuff') }}<br/>
                            Staff: {{ filterScriptItemsByType(item.id, 'staff') }}<br/>
                            Service: {{ filterScriptItemsByType(item.id, 'service') }}
                        </template>
                        <template v-slot:cell(spaceItems)="{ item }">
                            {{ filterScriptItemsByType(item.id, 'space') }}
                        </template>
                        <template v-slot:cell(stuffItems)="{ item }">
                            {{ filterScriptItemsByType(item.id, 'stuff') }}
                        </template>
                        <template v-slot:cell(staffItems)="{ item }">
                            {{ filterScriptItemsByType(item.id, 'staff') }}
                        </template>
                        <template v-slot:cell(serviceItems)="{ item }">
                            {{ filterScriptItemsByType(item.id, 'service') }}
                        </template>
                    </b-table>
                </b-card>
            </div>
            <div class="col-xl-3">
                <div>
                    <div role="tablist">
                        <b-card no-body class="p-0">
                            <b-card-header header-tag="header" class="p-0" role="tab">
                                <b-button block v-b-toggle.tab1 variant="light">Filters</b-button>
                            </b-card-header>
                            <b-collapse id="tab1" visible role="tabpanel">
                                <b-card-body>
                                    <label class="width-full"><b>Search:</b>
                                        <input v-model="search" placeholder="Search item" type="search" class="form-control" />
                                    </label>
                                    <label class="width-full"><b>Storyboard:</b>
                                        <select v-model="storyboardFilter" class="form-control" @change="stageFilter = 'all'">
                                            <option value="all" selected>All</option>
                                            <option v-for="sb in $parent.$parent.$parent.filterEventStoryboards(activeEvent.id)" :key="sb.id" :value="sb.id">{{ sb.name }}</option>
                                        </select>
                                    </label>
                                    <label class="width-full"><b>Stage:</b>
                                        <select v-model="stageFilter" class="form-control">
                                            <option value="all" selected>All</option>
                                            <option v-for="stage in $parent.$parent.$parent.filterEventStages(activeEvent.id, storyboardFilter)" :key="stage.id" :value="stage.id">{{ stage.name }}</option>
                                        </select>
                                    </label>
                                    <label class="width-full"><b>Confirmed:</b>
                                        <select v-model="confirmedFilter" class="form-control" @change="stageFilter = 'all'">
                                            <option value="all" selected>All</option>
                                            <option :value="true">Yes</option>
                                            <option :value="false" >No</option>
                                        </select>
                                    </label>
                                    <label class="width-full"><b>Empty scripts:</b>
                                        <b-form-checkbox switch v-model="emptyScriptFilter" @change="checkEmptyFilters">Only empty scripts</b-form-checkbox>
                                    </label>
                                    <label class="width-full"><b>Steps missing space info:</b>
                                        <b-form-checkbox switch v-model="emptySpaceFilter" @change="checkScriptFilterStatus">Only missing space info</b-form-checkbox>
                                    </label>
                                    <label class="width-full"><b>Steps missing stuff info:</b>
                                        <b-form-checkbox switch v-model="emptyStuffFilter" @change="checkScriptFilterStatus">Only missing stuff info</b-form-checkbox>
                                    </label>
                                    <label class="width-full"><b>Steps missing staff info:</b>
                                        <b-form-checkbox switch v-model="emptyStaffFilter" @change="checkScriptFilterStatus">Only missing staff info</b-form-checkbox>
                                    </label>
                                    <label class="width-full"><b>Steps missing service info:</b>
                                        <b-form-checkbox switch v-model="emptyServiceFilter" @change="checkScriptFilterStatus">Only missing service info</b-form-checkbox>
                                    </label>
                                    <input-button type="button" @click="resetFilters" label="Reset filters" class="btn-yellow mt-2" />
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                        <b-card no-body class="p-0">
                            <b-card-header header-tag="header" class="p-0" role="tab">
                                <b-button block v-b-toggle.tab2 variant="light">Selected Items</b-button>
                            </b-card-header>
                            <b-collapse id="tab2" visible role="tabpanel">
                                <b-card-body>
                                    <b-card-text>
                                        <p v-if="!selectedItems.length">No items selected.</p>
                                        <ul>
                                            <li class="mb-2" v-for="(selectedItem, index) in selectedItems" :key="selectedItem.id">
                                                {{ selectedItem.name }}
                                                <b-button v-b-tooltip.left="'Unselect item'" class="btn btn-danger btn-icon btn-circle btn-sm pull-right" @click="unselect(index)">
                                                    <i class="fa fa-times" />
                                                </b-button>
                                            </li>
                                        </ul>
                                    </b-card-text>
                                    <div v-if="selectedItems.length">
                                        <b-button @click="selectAction" class="btn-yellow">Select</b-button>
                                        <input-button type="button" @click="unselectAll" label="Unselect all" class="btn-danger pull-right" />
                                    </div>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                </div>
            </div>
        </div>

        <div class="row m-t-10">
            <div class="col-6">
            <label><b>Per page</b>
                <b-form-select v-model="perPage" :options="perPageOptions" />
            </label>
            </div>
            <b-pagination class="col-6 pagination" next-class="{ background-color: red; }" align="right" v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="itemTable" />    
        </div>
    </div>
</template>

<script>
import InputButton from '../buttons/InputButton.vue'

export default {
    name: 'SearchTable',
    props: ['storyboards', 'stages', 'steps', 'activeEvent', 'selectedSteps', 'scriptItems'],
    components: {
        InputButton
    },
    data() {
        return {
            itemsCheck: false,
            selectedItems: [],
            search: '',
            storyboardFilter: 'all',
            stageFilter: 'all',
            confirmedFilter: 'all',
            emptyScriptFilter: false,
            emptySpaceFilter: false,
            emptyStuffFilter: false,
            emptyStaffFilter: false,
            emptyServiceFilter: false,
            perPageOptions: [ 5, 10, 25, 50, 100 ],
            perPage: 10,
            currentPage: 1,
            fields: [
                { key: 'selected', sortable: false },
                { key: 'image', sortable: false },
                { key: 'name', sortable: true },
                {
                    key: 'stage',
                    sortable: true,
                    formatter: (value, key, item) => {
                        return this.$parent.$parent.$parent.getStage(item.stage).name
                    },
                    sortByFormatted: true,
                },
                
                {
                    key: 'storyboard',
                    sortable: true,
                    formatter: (value, key, item) => {
                        return this.$parent.$parent.$parent.getStoryboard(item.stage).name
                    },
                    sortByFormatted: true,
                },
                { key: 'confirmed', sortable: false },
                { key: '4SItems', sortable: false },
                //{ key: 'spaceItems', sortable: false },
                //{ key: 'stuffItems', sortable: false },
                //{ key: 'staffItems', sortable: false },
                //{ key: 'serviceItems', sortable: false },
            ]
        }
    },
    computed: {
        rows() {
            return this.itemsInType(this.activeEvent.id).length;
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    methods: {
        filterEventSteps(event) {
            var storyboards = this.$parent.$parent.$parent.filterEventStoryboards(event);
            var fStepIds = [];
            var fSteps = [];
            storyboards.forEach(sb => {
                var stages = this.stages.filter(function(stage) {
                    return stage.storyboard == sb.id
                });
                stages.forEach(stage => {
                    stage.steps.forEach(step => {
                        fStepIds.push(step.id);
                    });
                });
            });
            this.steps.forEach(step => {
                if (fStepIds.includes(step.id)) {
                    fSteps.push(step);
                }
            });
            return fSteps;
        },
        getImage(image) {
            if (image == null) {
                return require('../../assets/images/no_image.jpg');
            } else {
                return process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd;
            }
        },
        getUsage(currentItemId) {
            let usageString = "Not in use.";
            this.scriptItems.forEach(scriptItem => {
                if (scriptItem.confirmed && currentItemId == scriptItem.item) {
                    if (usageString == 'Not in use.') {
                        usageString = scriptItem.amount + " in " + scriptItem.step.name;
                    } else {
                        usageString += ", " + scriptItem.amount + " in " + scriptItem.step.name;
                    }
                }
            });
            return usageString;
        },
        fileType(path) {
           return path.slice(path.lastIndexOf('.') + 1);
        },
        itemsInType(event) {
            let self = this;
            let items = this.filterEventSteps(event);
            return items.filter(function (item) {
                var itemStoryboard = self.$parent.$parent.$parent.getStoryboard(item.stage);
                if (itemStoryboard.id == self.storyboardFilter || self.storyboardFilter == "all") {
                    var itemStage = self.$parent.$parent.$parent.getStage(item.stage);
                    if (itemStage.id == self.stageFilter || self.stageFilter == "all") {
                        if (self.confirmedFilter == true && self.checkStepStatus(item) || !self.confirmedFilter == true && !self.checkStepStatus(item) || self.confirmedFilter == "all") {
                            if (self.emptySpaceFilter && !self.filterScriptItemsByType(item.id, 'space') || !self.emptySpaceFilter) {
                            if (self.emptyStaffFilter && !self.filterScriptItemsByType(item.id, 'stuff') || !self.emptyStaffFilter) {
                            if (self.emptyStuffFilter && !self.filterScriptItemsByType(item.id, 'staff') || !self.emptyStuffFilter) {
                            if (self.emptyServiceFilter && !self.filterScriptItemsByType(item.id, 'service') || !self.emptyServiceFilter) {
                                if (self.search) {
                                    if (item.name.toLowerCase().includes(self.search.toLowerCase())) {
                                        return item;
                                    }
                                } else {
                                    return item;
                                } 
                            }
                            }
                            }
                            }
                        }
                    }
                }
            })
        },
        checkEmptyFilters() {
            this.emptySpaceFilter = true;
            this.emptyStuffFilter = true;
            this.emptyStaffFilter = true;
            this.emptyServiceFilter = true;
        },
        checkScriptFilterStatus() {
            if (
                this.emptySpaceFilter == true &&
                this.emptyStuffFilter == true &&
                this.emptyStaffFilter == true &&
                this.emptyServiceFilter == true
            ) {
                this.emptyScriptFilter = true;
            } else {
                this.emptyScriptFilter = false;
            }
        },
        checkStepStatus(step) {
            if (step.space && step.staff && step.stuff && step.service) {
                return true
            } else {
                return false
            }
        },
        resetFilters() {
            this.search = '';
            this.storyboardFilter = 'all';
            this.stageFilter = 'all';
            this.confirmedFilter = 'all';
            this.emptyScriptFilter = false;
            this.emptySpaceFilter = false;
            this.emptyStuffFilter = false;
            this.emptyStaffFilter = false;
            this.emptyServiceFilter = false;
        },
        selectAction() {
            this.$parent.$parent.$parent.filterSelectedSteps(this.selectedItems);
        },
        checkAll(checked) {
            if (checked) {
                let itemsInType = this.itemsInType(this.activeEvent.id);
                itemsInType.forEach(itemInType => {
                    if (!this.selectedItems.find(selectedItem => selectedItem.id == itemInType.id)) {
                        this.selectedItems.push(itemInType);
                    }
                });
            } else {
                let itemsInType = this.itemsInType(this.activeEvent.id);
                itemsInType.forEach(itemInType => {
                    let index = this.selectedItems.findIndex(selectedItem => selectedItem.id == itemInType.id);
                    if (index != -1) {
                        this.selectedItems.splice(index, 1);
                    }
                });
            }
        },
        itemCheck(checked) {
            if(!checked) {
                this.itemsCheck = false;
            }
        },
        unselect(index) {
            this.itemsCheck = false;
            this.selectedItems.splice(index, 1);
        },
        unselectAll() {
            this.selectedItems = [];
            this.itemsCheck = false;
        },
        setSelected() {
            if (this.selectedSteps && this.selectedSteps.length) {
                this.selectedItems = this.selectedSteps
                if (this.selectedItems.length == this.itemsInType(this.activeEvent.id).length) {
                    this.itemsCheck = true;
                }
            }
        },
        filterScriptItemsByType(stepId, typeParam) {
            let typeId = 1;
            switch (typeParam) {
                case 'service':
                    typeId = 1;
                    break;
                case 'space':
                    typeId = 2;
                    break;
                case 'staff':
                    typeId = 3;
                    break;
                case 'stuff':
                    typeId = 4;
                    break;
                default:
                    typeId = 1;
                    break;
            }
            var filteredScriptItems = this.scriptItems.filter(function(scriptItem) {
                return scriptItem.step.id == stepId && scriptItem.item.type == typeId && scriptItem.confirmed
            })
            return filteredScriptItems.length;
        }
    },
    mounted() {
        this.setSelected();
    },
    watch: {
        emptySpaceFilter () {
            this.checkScriptFilterStatus();
        },
        emptyStuffFilter () {
            this.checkScriptFilterStatus();
        },
        emptyStaffFilter () {
            this.checkScriptFilterStatus();
        },
        emptyServiceFilter () {
            this.checkScriptFilterStatus();
        }
    }
}
</script>